import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout: React.FC = () => {
    const location = useLocation();
    const isTightFooterPage =
        location.pathname.startsWith('/about') ||
        location.pathname.startsWith('/services/china/personal/digital');

    return (
        <>
            <Header />
            <main>
                <Outlet key={location.pathname} />
            </main>
            <Footer className={isTightFooterPage ? 'footer-no-top-gap' : ''} />
        </>
    );
};

export default Layout;
